import { useCallback, useEffect, useState } from 'react';
import { analyticsService } from '../services/analyticsService';

const RECORDS_DATASET = 'records';

export default function useAnalyticsForms(dataset, campaignIds = []) {
  const [forms, setForms] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const idsKey = campaignIds.filter(Boolean).join('|');

  const load = useCallback(async () => {
    const ids = idsKey ? idsKey.split('|') : [];
    if (dataset !== RECORDS_DATASET || !ids.length) {
      setForms([]);
      setIsLoading(false);
      return;
    }

    setIsLoading(true);
    const results = await Promise.all(ids.map((id) => analyticsService.getForms(id)));
    const merged = [];
    const seen = new Set();
    results.forEach((res) => {
      (res.ok ? res.data?.forms || [] : []).forEach((form) => {
        const formId = form?.leads_form_id;
        if (!formId || seen.has(String(formId))) return;
        seen.add(String(formId));
        merged.push(form);
      });
    });
    setForms(merged);
    setIsLoading(false);
  }, [dataset, idsKey]);

  useEffect(() => {
    load();
  }, [load]);

  return { forms, isLoading, reload: load };
}
